import React from 'react';
import {connect} from 'react-redux';
import { toast } from 'react-toastify';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {Flex} from '/app/src/component';
import style from './style.css';
import {SVGButton} from '/app/src/component'
import Modal from 'react-responsive-modal';
import InfoBubble from './InfoBubble';

class Installation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            installText:
`<!-- Start of Jibber Chat Code -->
<script
    id="Jibber"
    type="text/javascript"
    src="https://client.jibber.social/client-api/js/app.js?id=${this.props.companyId}">
</script>
<!--- End of Jibber Code -->`,
            exampleCode:
`
    <!Doctype html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width">
        <title>Example Page</title>
    </head>
    <body>
        <h1> Hej och välkommen till vår hemsida </h1>
        <!-- Start of Jibber Chat Code -->
        <script
            id="Jibber"
            type='text/javascript'
            src='https://client.jibber.social/client-api/js/app.js?id=${this.props.companyId}'>
        </script>
        <!--- End of Jibber Code -->
    </body>
    </html>
`,
            modal: false
        }

        this.closeModal = this.closeModal.bind(this);
        this.openModal = this.openModal.bind(this);

    }


    copyNotification() {

        return(
            toast.info("Texten är kopierad")
        );

    };

    closeModal(){
        this.setState({
            modal: false
        })
    }

    openModal(){
        this.setState({
            modal: true
        })
    }

    render() {
        return (
            <Flex width="100%">
                <Flex width="100%" height='100%' shrink={0} column center>
                    <Flex width='100%' hAlignContent='center' className={style.BubbleRow}>
                        <InfoBubble color= "#f54a7e" BackgroundColor = "#4dc6e3" HeadingText = "Kopiera" Number = "1" description="Kopiera koden." />
                        <InfoBubble color= "#f2c670" BackgroundColor = "#f54a7e" HeadingText = "Installera" Number = "2" description="Klistra in koden precis innan </body> på er hemsida." />
                        <InfoBubble color= "#9bce9b" BackgroundColor = "#ff9900" HeadingText = "Börja Chatta" Number = "3" description= "Nu kan ni köra igång!" />
                    </Flex>
                    <Flex column width='80%' className={style.InstallationInfo}>
                        <Flex>{'Ni måste lägga in koden på er hemsida för att chattbubblan ska visas. Har ni inte tillgång till er hemsidas källkod får ni kontakta er webbadministratör. Ert företags-ID är ' + this.props.companyId}.</Flex>
                        <Flex>
                            <p className={style.SeeExampleText} onClick={this.openModal}>Se exempel...</p>

                        </Flex>

                        <Flex><p>Klicka <a target="_blank" className={style.DemoLink} href={`https://jibber.se/demo/${this.props.companyDemo}`}>här</a> för att se chatten live på vår demosida.</p></Flex>
                    </Flex>

                    <Flex column width="100%">
                        <Flex width='100%' className={style.InstallationScript} hAlignContent='center'>
                            <Flex className={style.InstallScriptBorder} width='80%'>
                                <pre ref={pre => {this.installScriptText = pre;}} className={style.InstallScriptText}>
                                {this.state.installText}
                                </pre>
                            </Flex>
                        </Flex>
                        <Flex hAlignContent='center'>
                            <CopyToClipboard text={this.state.installText}>
                                <SVGButton my='35px' text='Kopiera' src='/images/Chat_QuickResponse.svg' onClick={this.copyNotification} border color='black' hover='blue' className={style.CopyButton}/>
                            </CopyToClipboard>
                        </Flex>
                    </Flex>
                    {this._renderExampleModal()}
                </Flex>
            </Flex>

        )
    }
    _renderExampleModal(){
        return (
            <Modal
                styles={{modal: {padding: '0px', background: 'none', boxShadow: 'none'}}}
                showCloseIcon={false}
                open={this.state.modal}
                onClose={this.closeModal}
                center
            >
            <Flex className={style.ExampleCodeBorder} column>
                <pre  className={style.ExampleCode}>
{`
<!Doctype html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width">
    <title>Example Page</title>
</head>
<body>
    <h1> Hej och välkommen till vår hemsida </h1>
`}
</pre>
<pre>{
this.state.installText
}
</pre>
<pre  className={style.ExampleCode}>
{`
</body>
</html>
`}

            </pre>
            </Flex>
            </Modal>
        )
    }
}

function mapStateToProps(state, props){
    return {
        companyId: state.getIn(['company', 'info', 'id']),
        companyDemo: state.getIn(['company', 'info', 'demo']),
    }
}

export default connect(mapStateToProps)(Installation);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/CompanySettings/Installation/index.js